var map = {
	"./drdoctor/img/icons/share_icon.png": 644,
	"./freedoctor/img/icons/share_icon.png": 645,
	"./freelegal/img/icons/share_icon.png": 646,
	"./legalchief/img/icons/share_icon.png": 647,
	"./medi4u/img/icons/share_icon.png": 648
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 643;